import { MdlDialogReference, MdlDialogService } from '@angular-mdl/core';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { FileToLanguage } from '../../../../covance-file-upload/covance-file-upload.component';
import { FileFormArray } from '../../../../covance-file-upload/file-form-array';
import { FileLink, GeneralReport, Report } from '../../../../documents';
import { FileExtensions } from '../file-extensions';
import { UploadedDocumentsStorage } from '../../storages/uploaded-documents-storage';
import { UploadedTranslationsStorage } from './uploaded-translations-storage';
import { CustomMethodUploadOptions } from '../base/method-upload-options';
import { UploadDialogData, UPLOAD_DLG_DATA_TOKEN } from '../base/upload-dialog-data';
import { UpdateDocumentDialogBase } from './../base/update-document-dialog-base';

@Component({
    selector: 'document-translation-upload',
    template: require('./document-translation-upload.component.html'),
    styles: [require('./document-translation-upload.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentTranslationUploadComponent extends UpdateDocumentDialogBase {
    public readonly languages: FileLink[] = [];
    public readonly subcategory: string;
    public readonly title: string;
    public readonly letterNumber: string;
    public readonly fileFormArray: FileFormArray;
    public readonly allowedFileExtensions: string[];
    public readonly excludeLanguageIds: string[];
    public readonly excludeFileNames: string[];
    public readonly report: Report;

    public selectedFiles: FileToLanguage;

    constructor(
        dialog: MdlDialogReference,
        dialogService: MdlDialogService,
        private readonly uploadedDocumentsStorage: UploadedDocumentsStorage,
        private readonly uploadedTranslationsStorage: UploadedTranslationsStorage,
        @Inject(UPLOAD_DLG_DATA_TOKEN) readonly dialogData: UploadDialogData<GeneralReport>,
        readonly fileExtensions: FileExtensions,
    ) {
        super(
            uploadedDocumentsStorage,
            dialog,
            dialogService,
            dialogData.category.categoryId);

        this.subcategory = dialogData.report.subcategoryTitle;
        this.title = dialogData.report.title;
        this.letterNumber = dialogData.report.letterNumber;
        this.report = dialogData.report;
        this.languages = dialogData.report.fileLinks;
        this.excludeLanguageIds = dialogData.report.fileLinks.map(l => l.languageId);
        this.excludeFileNames = dialogData.report.fileLinks.map(l => l.uploadFileName);
        this.fileFormArray = new FileFormArray();
        
        this.editorForm.addControl('files', this.fileFormArray);

        this.allowedFileExtensions = fileExtensions.getAllowedFileExtensions(dialogData.report);
    }

    public onFilesChanged(selectedFiles: FileToLanguage) {
        this.selectedFiles = selectedFiles;
    }

    public async add() {

        const title = this.dialogData.report.title ? ` ${this.dialogData.report.title}` : '';
        const message = `You are going to upload translation for a document${title}. Proceed?`;

        const confirmed = await this.showConfirm(message);
        
        if (confirmed) {
            this.upload(new CustomMethodUploadOptions(
                () => this.uploadedTranslationsStorage.upload(
                    this.selectedFiles,
                    this.dialogData.report.fileLinkCategory,
                    this.dialogData.report.reportId),
                () => this.uploadedDocumentsStorage.forceLoadDocuments()
            ));
        }
    }
}